import React from 'react';
import styled from '@nykaa/ui-components/styles/styled';

const StyledSvg = styled.span`
  position: fixed;
  top: 91px;
  right: 53px;
`;

interface PositionedSvgProps {
  width?: number;
  height?: number;
  className?: string;
}

const PositionedSvg: React.FC<PositionedSvgProps> = () => (
  <StyledSvg>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="8" viewBox="0 0 20 8" fill="none">
      <path d="M0 10.7674L8.47035 0.711598C9.26947 -0.2371 10.7305 -0.237102 11.5296 0.711596L20 10.7674H0Z" fill="#F2F2F1" />
    </svg>
  </StyledSvg>
);

export default PositionedSvg;
